module.exports = __webpack_public_path__ + "documentacao.png?14d3224c09391e029d1aae8ae0d8991d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/documentacao.png
// module id = 734
// module chunks = 0